module.exports = __webpack_public_path__ + "static/media/line-firula.aa06029e.png";